export default __webpack_public_path__ + "static/media/img3.4eea8de7.png";